import { render, staticRenderFns } from "./ProductSelectBottomFooter.vue?vue&type=template&id=9a7f042a&scoped=true"
import script from "./ProductSelectBottomFooter.vue?vue&type=script&lang=js"
export * from "./ProductSelectBottomFooter.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectBottomFooter.vue?vue&type=style&index=0&id=9a7f042a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7f042a",
  null
  
)

export default component.exports